import { eventsApiUrl, getApiBase } from "./apiConfig";
import { adminAuthedFetch } from "./adminAuthedFetch";
import { getAdminJwt } from "./authToken";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const STORAGE_KEY = "vii_events_v1";

const PLACEHOLDER_IMAGE =
  "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1200&q=70";

const AUTHOR_LABELS = { hassan: "Getty Denkyi" };

const mockEvents = [
  {
    id: "e1",
    category: "Business",
    tag: "Travel",
    date: "2020-07-02",
    title: "Your most unhappy customers are your greatest source of learning.",
    excerpt:
      "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.",
    content:
      "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.\n\nA small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.\n\nEven the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.",
    author: { name: "Sergy Campbell", role: "CEO and Founder" },
    imageUrl:
      "https://images.unsplash.com/photo-1485955900006-10f4d324d411?auto=format&fit=crop&w=1200&q=70",
    featured: true,
    gallery: [
      {
        url: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=900&q=70",
        sortOrder: 0,
      },
      {
        url: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=900&q=70",
        sortOrder: 1,
      },
      {
        url: "https://images.unsplash.com/photo-1426604966848-d7adac402bff?auto=format&fit=crop&w=900&q=70",
        sortOrder: 2,
      },
    ],
  },
  {
    id: "e2",
    category: "Business",
    tag: "Travel",
    date: "2020-07-02",
    title: "Your most unhappy customers are your greatest source of learning.",
    excerpt:
      "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    content:
      "The Big Oxmox advised her not to do so, because there were thousands of bad Commas, wild Question Marks and devious Semikoli, but the Little Blind Text didn’t listen.\n\nShe packed her seven versalia, put her initial into the belt and made herself on the way. When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, the headline of Alphabet Village and the subline of her own road, the Line Lane.",
    author: { name: "Sergy Campbell", role: "CEO and Founder" },
    imageUrl:
      "https://images.unsplash.com/photo-1459666644539-a9755287d6b0?auto=format&fit=crop&w=1200&q=70",
  },
  {
    id: "e3",
    category: "Business",
    tag: "Travel",
    date: "2020-07-02",
    title: "Your most unhappy customers are your greatest source of learning.",
    excerpt:
      "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    content:
      "Pityful a rethoric question ran over her cheek, then she continued her way. On her way she met a copy. The copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times and everything that was left from its origin would be the word \"and\".\n\nThe copy said the Little Blind Text should turn around and return to its own safe country. But nothing the copy said could convince her and so it didn’t take long until a few insidious Copy Writers ambushed her.",
    author: { name: "Sergy Campbell", role: "CEO and Founder" },
    imageUrl:
      "https://images.unsplash.com/photo-1519710164239-da123dc03ef4?auto=format&fit=crop&w=1200&q=70",
  },
  {
    id: "e4",
    category: "Business",
    tag: "Travel",
    date: "2020-07-02",
    title: "Your most unhappy customers are your greatest source of learning.",
    excerpt:
      "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    content:
      "Made her drunk with Longe and Parole and dragged her into their agency, where they abused her for their projects again and again. And if she hasn’t been rewritten, then they are still using her.\n\nFar far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.",
    author: { name: "Sergy Campbell", role: "CEO and Founder" },
    imageUrl:
      "https://images.unsplash.com/photo-1482849737880-498de71dda1f?auto=format&fit=crop&w=1200&q=70",
  },
  {
    id: "e5",
    category: "Business",
    tag: "Travel",
    date: "2020-07-02",
    title: "Your most unhappy customers are your greatest source of learning.",
    excerpt:
      "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    content:
      "A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.\n\nEven the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.",
    author: { name: "Sergy Campbell", role: "CEO and Founder" },
    imageUrl:
      "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=1200&q=70",
  },
  {
    id: "e6",
    category: "Business",
    tag: "Travel",
    date: "2020-07-02",
    title: "Your most unhappy customers are your greatest source of learning.",
    excerpt:
      "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    content:
      "The Big Oxmox advised her not to do so, because there were thousands of bad Commas, wild Question Marks and devious Semikoli, but the Little Blind Text didn’t listen. She packed her seven versalia, put her initial into the belt and made herself on the way.\n\nWhen she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove.",
    author: { name: "Sergy Campbell", role: "CEO and Founder" },
    imageUrl:
      "https://images.unsplash.com/photo-1472214103451-9374bd1c798e?auto=format&fit=crop&w=1200&q=70",
  },
  {
    id: "e7",
    category: "Business",
    tag: "Travel",
    date: "2020-07-02",
    title: "Your most unhappy customers are your greatest source of learning.",
    excerpt:
      "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    content:
      "The headline of Alphabet Village and the subline of her own road, the Line Lane. Pityful a rethoric question ran over her cheek, then she continued her way. On her way she met a copy.\n\nThe copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times and everything that was left from its origin would be the word \"and\" and the Little Blind Text should turn around and return to its own, safe country.",
    author: { name: "Sergy Campbell", role: "CEO and Founder" },
    imageUrl:
      "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1200&q=70",
  },
];

function remoteEventsEnabled() {
  return Boolean(getApiBase());
}

function cloneMockEvents() {
  return mockEvents.map((e) => ({
    ...e,
    author: { ...e.author },
  }));
}

function readStoredEvents() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return null;
    return parsed;
  } catch {
    return null;
  }
}

function writeStoredEvents(events) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(events));
  } catch {
    // ignore
  }
}

function getLocalEventsSnapshot() {
  const stored = readStoredEvents();
  if (stored !== null) {
    return stored.map((e) =>
      withDerivedGalleryUrls({
        ...e,
        author: e.author && typeof e.author === "object" ? { ...e.author } : { name: "", role: "" },
      })
    );
  }
  return cloneMockEvents().map(withDerivedGalleryUrls);
}

function galleryFirstUrl(gallery) {
  if (!Array.isArray(gallery) || !gallery.length) return "";
  const sorted = [...gallery].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
  return sorted[0]?.url || "";
}

function galleryUrlsFromRaw(raw) {
  const g = raw.gallery;
  if (!Array.isArray(g) || !g.length) return [];
  const sorted = [...g].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
  const urls = [];
  const seen = new Set();
  for (const item of sorted) {
    const u = item?.url != null ? String(item.url).trim() : "";
    if (!u || seen.has(u)) continue;
    seen.add(u);
    urls.push(u);
  }
  return urls;
}

export function getGalleryUrlsForEvent(event) {
  if (!event) return [];
  if (Array.isArray(event.galleryUrls) && event.galleryUrls.length > 0) return event.galleryUrls;
  if (event._raw) return galleryUrlsFromRaw(event._raw);
  return galleryUrlsFromRaw({ gallery: event.gallery });
}

function withDerivedGalleryUrls(e) {
  const urls =
    Array.isArray(e.galleryUrls) && e.galleryUrls.length > 0
      ? e.galleryUrls
      : galleryUrlsFromRaw({ gallery: e.gallery });
  return { ...e, galleryUrls: urls };
}

function mapAuthorFromApi(raw) {
  const publishedBy = raw.PublishedBy;
  const a = raw.author != null ? raw.author : publishedBy;
  if (a && typeof a === "object") {
    const name = a.name || a.email || "";
    return { name: String(name), role: String(a.role || "") };
  }
  if (typeof a === "string") {
    const key = a.trim().toLowerCase();
    if (AUTHOR_LABELS[key]) return { name: AUTHOR_LABELS[key], role: "" };
    return { name: a, role: "" };
  }
  return { name: "", role: "" };
}

function dateFromApi(raw) {
  const pd = raw.publishDate;
  if (typeof pd === "string" && pd.length >= 10) return pd.slice(0, 10);
  const c = raw.createdAt;
  if (typeof c === "string" && c.length >= 10) return c.slice(0, 10);
  try {
    return new Date(raw.publishDate || raw.createdAt || Date.now()).toISOString().slice(0, 10);
  } catch {
    return "";
  }
}

export function normalizeApiEvent(raw) {
  const id = raw._id != null ? String(raw._id) : raw.id != null ? String(raw.id) : "";
  const category = (raw.category && String(raw.category).trim()) || "General";
  const tag = (raw.tag && String(raw.tag).trim()) || category || "Event";
  const imageUrl =
    (raw.coverUrl && String(raw.coverUrl).trim()) ||
    (raw.coverImageLink && String(raw.coverImageLink).trim()) ||
    galleryFirstUrl(raw.gallery) ||
    (raw.FileLink && String(raw.FileLink).trim()) ||
    PLACEHOLDER_IMAGE;

  return {
    id,
    title: raw.title || "",
    excerpt: raw.excerpt || "",
    content: raw.content || raw.excerpt || "",
    category,
    tag,
    date: dateFromApi(raw),
    author: mapAuthorFromApi(raw),
    imageUrl,
    galleryUrls: galleryUrlsFromRaw(raw),
    featured: false,
    _apiStatus: raw.status || (raw.publishedAt ? "published" : undefined),
    _raw: raw,
  };
}

function withFeaturedFirst(list) {
  if (!list.length) return list;
  return list.map((e, i) => ({
    ...e,
    featured: i === 0,
  }));
}

export class EventApiError extends Error {
  constructor(message, { status, errors, body } = {}) {
    super(message);
    this.name = "EventApiError";
    this.status = status;
    this.errors = errors;
    this.body = body;
  }
}

export function normalizeEventForDashboardRow(ev) {
  const st = ev._apiStatus;
  const status = st === "published" ? "published" : "draft";
  const authorName =
    ev.author && typeof ev.author === "object" && String(ev.author.name || "").trim()
      ? String(ev.author.name)
      : "—";
  const raw = ev._raw || {};
  return {
    id: ev.id,
    title: ev.title || "Untitled",
    author: authorName,
    status,
    views: typeof raw.views === "number" ? raw.views : 0,
    date: ev.date || "—",
    _raw: raw,
  };
}

async function parseBodyText(res) {
  const text = await res.text();
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch {
    return { message: text };
  }
}

export async function createEventMultipart({
  title,
  excerpt,
  content,
  author,
  category,
  publishDate,
  status,
  coverFile,
  galleryFiles,
}) {
  if (!remoteEventsEnabled()) {
    throw new EventApiError("Events API is not configured", { status: 0 });
  }
  const token = getAdminJwt();
  if (!token) throw new EventApiError("Sign in required", { status: 401 });

  const form = new FormData();
  form.append("title", title ?? "");
  form.append("excerpt", excerpt ?? "");
  form.append("content", content ?? "");
  form.append("author", author ?? "");
  form.append("category", category ?? "");
  const pd = publishDate && String(publishDate).trim();
  if (pd) form.append("publish_date", pd);
  form.append("status", status === "published" ? "published" : "draft");

  if (coverFile) form.append("cover", coverFile);
  (galleryFiles || []).forEach((file) => {
    form.append("gallery", file);
  });

  const url = eventsApiUrl("");
  const res = await adminAuthedFetch(url, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: form,
  });

  const body = await parseBodyText(res);
  if (!res.ok) {
    const msg = body.message || "Could not create event";
    const errors = Array.isArray(body.errors) ? body.errors : [];
    throw new EventApiError(typeof msg === "string" ? msg : "Could not create event", {
      status: res.status,
      errors,
      body,
    });
  }
  return body;
}

function extractEventsArray(data) {
  if (Array.isArray(data)) return data;
  if (!data || typeof data !== "object") return [];
  if (Array.isArray(data.events)) return data.events;
  if (Array.isArray(data.data)) return data.data;
  if (Array.isArray(data.items)) return data.items;
  if (Array.isArray(data.results)) return data.results;
  if (Array.isArray(data.records)) return data.records;
  if (data.data && typeof data.data === "object") {
    if (Array.isArray(data.data.events)) return data.data.events;
    if (Array.isArray(data.data.items)) return data.data.items;
    if (Array.isArray(data.data.data)) return data.data.data;
  }
  return [];
}

function extractEventsTotalCount(data, listLength) {
  if (!data || typeof data !== "object") return listLength;
  const asInt = (v) => {
    if (typeof v === "number" && Number.isFinite(v) && v >= 0) return Math.floor(v);
    if (typeof v === "string" && /^\d+$/.test(v.trim())) return Math.floor(Number(v.trim()));
    return null;
  };
  const candidates = [
    data.total,
    data.totalCount,
    data.count,
    data.itemCount,
    data.meta && data.meta.total,
    data.pagination && data.pagination.total,
    data.pagination && data.pagination.totalCount,
    data._meta && data._meta.total,
    data.data && data.data.total,
    data.data && typeof data.data === "object" && data.data.pagination && data.data.pagination.total,
  ];
  for (const c of candidates) {
    const n = asInt(c);
    if (n != null) return n;
  }
  return listLength;
}

async function parseJson(res) {
  const text = await res.text();
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch {
    return { message: text };
  }
}

async function fetchPublishedFromApi() {
  const url = eventsApiUrl("retrieveEvents");
  const res = await fetch(url);
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(typeof data.message === "string" ? data.message : "Failed to load events");
  }
  const rows = extractEventsArray(data);
  return withFeaturedFirst(rows.map(normalizeApiEvent));
}

async function fetchAdminListFromApi() {
  const token = getAdminJwt();
  if (!token) {
    throw new Error("Sign in required to load all events");
  }
  const url = eventsApiUrl("admin/list");
  const res = await adminAuthedFetch(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(typeof data.message === "string" ? data.message : "Failed to load events");
  }
  const rows = extractEventsArray(data);
  const events = withFeaturedFirst(rows.map(normalizeApiEvent));
  const reportedTotal = extractEventsTotalCount(data, events.length);
  const total = Math.max(events.length, reportedTotal);
  return { events, total };
}

async function fetchOneFromApi(id, withAuth) {
  const url = eventsApiUrl(`retrieveEvent/${encodeURIComponent(id)}`);
  const headers = {};
  if (withAuth) {
    const token = getAdminJwt();
    if (token) headers.Authorization = `Bearer ${token}`;
  }
  const res =
    headers.Authorization || headers.authorization
      ? await adminAuthedFetch(url, { headers })
      : await fetch(url, { headers });
  const data = await parseJson(res);
  if (res.status === 404) return null;
  if (!res.ok) {
    throw new Error(typeof data.message === "string" ? data.message : "Failed to load event");
  }
  const doc =
    data._id != null || data.id != null
      ? data
      : data.event && (data.event._id != null || data.event.id != null)
        ? data.event
        : data.data && (data.data._id != null || data.data.id != null)
          ? data.data
          : null;
  if (!doc) return null;
  const normalized = normalizeApiEvent(doc);
  return normalized.id ? normalized : null;
}

export function resetEventsToDefaults() {
  if (remoteEventsEnabled()) return;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function usesRemoteEventsApi() {
  return remoteEventsEnabled();
}

export async function fetchEvents() {
  if (remoteEventsEnabled()) {
    return fetchPublishedFromApi();
  }
  await sleep(400);
  return getLocalEventsSnapshot().map((e) => ({
    ...e,
    author: { ...e.author },
  }));
}

export async function fetchAdminEventsListAndTotal() {
  if (remoteEventsEnabled()) {
    return fetchAdminListFromApi();
  }
  await sleep(400);
  const list = getLocalEventsSnapshot().map((e) => ({
    ...e,
    author: { ...e.author },
  }));
  return { events: list, total: list.length };
}

export async function fetchEventsForAdmin() {
  const { events } = await fetchAdminEventsListAndTotal();
  return events;
}

export async function fetchEventById(id) {
  if (remoteEventsEnabled()) {
    const withAuth = Boolean(getAdminJwt());
    const ev = await fetchOneFromApi(id, withAuth);
    return ev;
  }
  await sleep(200);
  const found = getLocalEventsSnapshot().find((e) => e.id === id);
  if (!found) return null;
  return { ...found, author: { ...found.author } };
}

export async function deleteEvent(id) {
  if (remoteEventsEnabled()) {
    const token = getAdminJwt();
    if (!token) return false;
    const url = eventsApiUrl(`deleteEvent/${encodeURIComponent(id)}`);
    const res = await adminAuthedFetch(url, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await parseJson(res);
    if (res.status === 204 || res.ok) return true;
    throw new Error(typeof data.message === "string" ? data.message : "Delete failed");
  }

  await sleep(200);
  let list = getLocalEventsSnapshot();
  const next = list.filter((e) => e.id !== id);
  if (next.length === list.length) return false;
  if (next.length === 0) {
    writeStoredEvents([]);
    return true;
  }
  const removedWasFeatured = list.find((e) => e.id === id)?.featured;
  if (removedWasFeatured || !next.some((e) => e.featured)) {
    next[0] = { ...next[0], featured: true };
  }
  writeStoredEvents(next);
  return true;
}

export async function updateEvent(id, updates) {
  if (remoteEventsEnabled()) {
    const token = getAdminJwt();
    if (!token) return null;
    const url = eventsApiUrl(`editEvent/${encodeURIComponent(id)}`);
    const body = {
      title: updates.title,
      excerpt: updates.excerpt,
      content: updates.content,
      category: updates.category,
      publishDate: updates.date,
      publish_date: updates.date,
      coverUrl: updates.imageUrl,
    };
    if (updates.tag) body.tag = updates.tag;
    if (updates.author && typeof updates.author === "object") {
      body.author =
        updates.author.name === "Getty Denkyi" && !updates.author.role
          ? "hassan"
          : updates.author.name;
    }
    const res = await adminAuthedFetch(url, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    const data = await parseJson(res);
    if (!res.ok) {
      throw new Error(typeof data.message === "string" ? data.message : "Update failed");
    }
    const doc = data.event || data.data || data;
    return doc ? normalizeApiEvent(doc) : normalizeApiEvent({ ...updates, _id: id, id });
  }

  await sleep(200);
  const list = getLocalEventsSnapshot();
  const idx = list.findIndex((e) => e.id === id);
  if (idx === -1) return null;

  const prev = list[idx];
  const nextAuthor =
    updates.author && typeof updates.author === "object"
      ? { ...prev.author, ...updates.author }
      : { ...prev.author };

  const { author: _a, featured: featPatch, ...rest } = updates;
  let merged = {
    ...prev,
    ...rest,
    author: nextAuthor,
  };

  let nextList;
  if (featPatch === true) {
    nextList = list.map((e, i) =>
      i === idx ? { ...merged, featured: true } : { ...e, featured: false }
    );
  } else if (featPatch === false) {
    merged = { ...merged, featured: false };
    nextList = list.map((e, i) => (i === idx ? merged : e));
    if (!nextList.some((e) => e.featured) && nextList[0]) {
      nextList = nextList.map((e, i) => (i === 0 ? { ...e, featured: true } : { ...e, featured: false }));
    }
  } else {
    nextList = list.map((e, i) => (i === idx ? merged : e));
  }

  writeStoredEvents(nextList);
  const saved = nextList.find((e) => e.id === id);
  return saved ? { ...saved, author: { ...saved.author } } : null;
}
